import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31231f81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Novo", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ss-tela-conteudo" }
const _hoisted_8 = { class: "ss-card ss-card-space" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS:")
], -1))
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_17 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_18 = { class: "ant-input-group-addon" }
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_22 = { style: {"text-align":"left","margin-top":"12px","margin-left":"5px"} }
const _hoisted_23 = {
  key: 0,
  style: {"text-align":"left","margin-left":"5px"}
}
const _hoisted_24 = { class: "ss-card ss-card-space ss-tela-conteudo-completo" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-texto-centralizado" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/ilustracoes/movimentacoes-conta.png",
    width: "250",
    alt: "Movimentações da conta"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "Extrato dos Movimentos"),
  /*#__PURE__*/_createElementVNode("span", null, "Selecione uma conta e o período para analisar")
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "ss-alinhar-texto-esquerda"
}
const _hoisted_29 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = { class: "ant-row ss-acoes-massa" }
const _hoisted_32 = {
  key: 0,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"30px"} }, "Conciliar", -1))
const _hoisted_34 = {
  key: 0,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data:", -1))
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor :", -1))
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 3 }
const _hoisted_47 = {
  key: 4,
  class: "acoes-item"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 2,
  title: "Visualizar Baixa"
}
const _hoisted_51 = {
  key: 3,
  title: "Visualizar Transferência"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { key: 5 }
const _hoisted_54 = { key: 6 }
const _hoisted_55 = { key: 7 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 9 }
const _hoisted_59 = {
  key: 2,
  style: {"height":"150px"}
}
const _hoisted_60 = { class: "ss-acoes-massa" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_filtro_periodo_movimento_conta = _resolveComponent("selecionar-filtro-periodo-movimento-conta")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_forma_visualizacao_movimento_conta = _resolveComponent("selecionar-forma-visualizacao-movimento-conta")!
  const _component_selecionar_conciliado = _resolveComponent("selecionar-conciliado")!
  const _component_selecionar_tipo_movimento_financeiro = _resolveComponent("selecionar-tipo-movimento-financeiro")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_movimento_financeiro_totalizadores = _resolveComponent("movimento-financeiro-totalizadores")!
  const _component_card = _resolveComponent("card")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_movimento_financeiro_modal = _resolveComponent("movimento-financeiro-modal")!
  const _component_baixa_titulos_modal = _resolveComponent("baixa-titulos-modal")!
  const _component_controle_periodo_movimentacao_contas_modal = _resolveComponent("controle-periodo-movimentacao-contas-modal")!
  const _component_transferencia_contas_modal = _resolveComponent("transferencia-contas-modal")!
  const _component_transferencia_contas_visualizacao_modal = _resolveComponent("transferencia-contas-visualizacao-modal")!
  const _component_importacao_extrato_ofx_modal = _resolveComponent("importacao-extrato-ofx-modal")!
  const _component_importacao_retorno_bancario_modal = _resolveComponent("importacao-retorno-bancario-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: _ctx.telaBase.titulo,
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, {
          BotoesAcoes: _withCtx(() => [
            (_ctx.UtilitarioGeral.validaCodigo(_ctx.state.contaSelecionada.codigo))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 'ACOES-MOVIMENTACAO-CONTA-' + _ctx.state.contaSelecionada.codigo + '-TP-' + _ctx.state.contaSelecionada.tipo,
                  class: "ss-principais-acoes",
                  style: _normalizeStyle(_ctx.storeSistema.state.layoutMobile ? 'margin-left: auto; margin-right: auto;' : '')
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Imprimir",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                    }, [
                      _createVNode(_component_icone, { nome: "imprimir" })
                    ]),
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Exportar Excel",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                    }, [
                      _createVNode(_component_icone, { nome: "excel" })
                    ]),
                    (_ctx.verificarAutorizacao('AUT_BAIXAS_CONTAS_PAGAR'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Baixar Contas a Pagar",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirecionarBaixaContasPagar()))
                        }, [
                          _createVNode(_component_icone, { nome: "saida" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.verificarAutorizacao('AUT_BAIXAS_CONTAS_RECEBER'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "ant-btn ant-btn-secondary ss-btn-recursos ss-botao-adicional",
                          title: "Baixar Contas a Receber",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirecionarBaixaContasReceber()))
                        }, [
                          _createVNode(_component_icone, { nome: "entrada" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.verificarAutorizacao('AUT_TRANSFERENCIA_ENTRE_CONTAS'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Transferência entre Contas",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.abrirTransferencia()))
                        }, [
                          _createVNode(_component_icone, { nome: "troca" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.verificarAutorizacao('AUT_MOVIMENTACOES_CONTAS_PERIODOS_FINANCEIROS'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Fechamento de Períodos",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.abrirControlePeriodoMovimentacao()))
                        }, [
                          _createVNode(_component_icone, { nome: "cadeado" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.verificarAutorizacao('AUT_IMPORTACAO_EXTRATO_OFX'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          class: "ant-btn ant-btn-secondary ss-btn-recursos ss-botao-adicional",
                          title: "Importar Extrato - OFX",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.abrirImportacaoOfx()))
                        }, [
                          _createVNode(_component_icone, { nome: "download" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Importar Retorno - RET",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.abrirImportacaoRetorno()))
                    }, [
                      _createVNode(_component_icone, { nome: "download" })
                    ]),
                    (_ctx.telaBase.permissaoDados.incluir)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          type: "button",
                          class: "ant-btn ant-btn-primary ss-btn-tela",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.incluir()))
                        }, _hoisted_6))
                      : _createCommentVNode("", true)
                  ])
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_selecionar_empresa, {
                  codigoSelecionado: _ctx.state.parametrosConsulta.empresa,
                  "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.parametrosConsulta.empresa) = $event)),
                  empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                  onChange: _ctx.atualizarSelecaoEmpresas
                }, null, 8, ["codigoSelecionado", "empresasEspecificas", "onChange"])
              ])
            ], 512), [
              [_vShow, _ctx.telaBase.apresentarEmpresas]
            ]),
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: _normalizeClass((_ctx.state.parametrosConsulta.periodo === _ctx.EFiltroPeriodoMovimentoConta.Personalizado)? 'ant-col ant-col-xs-24 ant-col-xl-11':'ant-col ant-col-xs-24 ant-col-xl-15')
                  }, [
                    _createVNode(_component_selecionar_conta, {
                      codigoSelecionado: _ctx.state.parametrosConsulta.conta,
                      "onUpdate:codigoSelecionado": [
                        _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.parametrosConsulta.conta) = $event)),
                        _cache[12] || (_cache[12] = ($event: any) => (_ctx.atualizarSelecaoConta()))
                      ],
                      empresas: [_ctx.state.parametrosConsulta.empresa],
                      verificarOperador: true,
                      "limpar-selecao": false,
                      usuarioOperando: _ctx.storeSistema.state.dadosUsuarioAutenticado.codigo,
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.buscarMovimentos(true)))
                    }, null, 8, ["codigoSelecionado", "empresas", "usuarioOperando"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.state.parametrosConsulta.periodo === _ctx.EFiltroPeriodoMovimentoConta.Personalizado?'ant-col ant-col-xs-24 ant-col-xl-4':'ant-col ant-col-xs-24 ant-col-xl-5')
                  }, [
                    _createVNode(_component_a_form_item, {
                      label: "Período",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_filtro_periodo_movimento_conta, {
                          valor: _ctx.state.parametrosConsulta.periodo,
                          "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.parametrosConsulta.periodo) = $event)),
                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.verificarAlteracaoPeriodo()))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ], 2),
                  ((_ctx.state.parametrosConsulta.periodo === _ctx.EFiltroPeriodoMovimentoConta.Personalizado))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_a_form_item, {
                          label: "Data Inicial e Final",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_data_inicial_final, {
                              dataInicialSelecionada: _ctx.state.parametrosConsulta.dataInicial,
                              "onUpdate:dataInicialSelecionada": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.parametrosConsulta.dataInicial) = $event)),
                              dataFinalSelecionada: _ctx.state.parametrosConsulta.dataFinal,
                              "onUpdate:dataFinalSelecionada": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.parametrosConsulta.dataFinal) = $event)),
                              onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.buscarMovimentos(true)))
                            }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "Forma de Visualização",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_forma_visualizacao_movimento_conta, {
                          valor: _ctx.state.parametrosConsulta.formaVisualizacao,
                          "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.parametrosConsulta.formaVisualizacao) = $event)),
                          onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.buscarMovimentos(true)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, [
                            _createVNode(_component_icone, {
                              class: "ss-icone",
                              nome: "pesquisar"
                            })
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.buscarMovimentos())),
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.parametrosConsulta.buscaRapida) = $event)),
                            class: "ant-input ss-alinhar-texto-esquerda",
                            placeholder: "Busca rápida: Digite o número de identificação, data, valor ou alguma informação..."
                          }, null, 544), [
                            [_vModelText, _ctx.state.parametrosConsulta.buscaRapida]
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, {
                      label: "Conciliados",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_conciliado, {
                          valor: _ctx.state.parametrosConsulta.conciliados,
                          "onUpdate:valor": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.parametrosConsulta.conciliados) = $event)),
                          onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.buscarMovimentos(true)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo Movimentos",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_tipo_movimento_financeiro, {
                          apresentarTodos: true,
                          valor: _ctx.state.parametrosConsulta.tipoMovimento,
                          "onUpdate:valor": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.parametrosConsulta.tipoMovimento) = $event)),
                          onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.buscarMovimentos(true)))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Apresenta a movimentos excluídos da Conta."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.state.parametrosConsulta.excluidos,
                            "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.parametrosConsulta.excluidos) = $event)),
                            onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.verificacaoFiltrosBoleanos()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Excluídos")
                            ]),
                            _: 1
                          }, 8, ["checked"])
                        ]),
                        _: 1
                      })
                    ]),
                    (!_ctx.state.parametrosConsulta.excluidos)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_a_tooltip, {
                            placement: "top",
                            title: "Apresentar somente movimentos que influênciaram o saldo da Conta."
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_checkbox, {
                                checked: _ctx.state.parametrosConsulta.influenciaSaldo,
                                "onUpdate:checked": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.parametrosConsulta.influenciaSaldo) = $event)),
                                onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.verificacaoFiltrosBoleanos()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Influenciam Saldo")
                                ]),
                                _: 1
                              }, 8, ["checked"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            ((!_ctx.UtilitarioGeral.validaCodigo(_ctx.state.parametrosConsulta.conta)))
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  ((_ctx.state.apresentarResultados))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_movimento_financeiro_totalizadores, {
                            saldoAnterior: _ctx.state.extratoConta.saldoAnterior,
                            totalRecebimentos: _ctx.state.extratoConta.recebimentos,
                            totalPagamentos: _ctx.state.extratoConta.pagamentos,
                            totalConciliados: _ctx.state.extratoConta.saldoConciliado,
                            saldo: _ctx.state.extratoConta.saldo
                          }, null, 8, ["saldoAnterior", "totalRecebimentos", "totalPagamentos", "totalConciliados", "saldo"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.storeSistema.state.layoutMobile && (_ctx.gradeBase.codigosSelecionados.length > 0))
                    ? (_openBlock(), _createBlock(_component_card, {
                        key: 1,
                        style: {"width":"100%"},
                        titulo: "Ações em massa"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.textoCodigosSelecionados()), 1),
                          _createElementVNode("div", _hoisted_31, [
                            ((_ctx.state.movimentosConciliar.length > 0))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("a", {
                                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.confirmarConciliacao && _ctx.confirmarConciliacao(...args))),
                                    style: {"text-align":"center"}
                                  }, [
                                    _createVNode(_component_icone, {
                                      nome: "checklist",
                                      class: "ss-icone-acao-massa-mobile"
                                    }),
                                    _hoisted_33
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_card, { titulo: "EXTRATO DOS MOVIMENTOS" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        ref: "scrollContainer",
                        onScroll: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
                        style: _normalizeStyle('height: ' + _ctx.defineAlturaScroll(45) +'px;overflow-y: auto;')
                      }, [
                        _createVNode(_component_a_table, {
                          columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                          "data-source": _ctx.state.movimentosVisiveis,
                          rowKey: "codigo",
                          pagination: false,
                          carregandoMovimentosFinanceiros: _ctx.telaBase.carregando,
                          scroll: _ctx.storeSistema.state.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +150) },
                          "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                          size: "small"
                        }, {
                          headerCell: _withCtx(({ column }) => [
                            _createVNode(_component_coluna_grade, {
                              column: column,
                              ordenacaoSelecionada: _ctx.telaBase.ordenacaoSelecionada,
                              "onUpdate:ordenacaoSelecionada": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                              filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                              "onUpdate:filtrosCabecalho": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                              onBuscarDados: _cache[34] || (_cache[34] = ($event: any) => (_ctx.buscarMovimentos(true)))
                            }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho"])
                          ]),
                          bodyCell: _withCtx(({ column, record, text }) => [
                            (column.key === 'Movimento')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createElementVNode("span", null, [
                                    _hoisted_35,
                                    _createTextVNode(" " + _toDisplayString(record.descricaoTipoDocumentoFinanceiro), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_36,
                                    _createTextVNode(),
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.visualizar(record.codigo))
                                    }, _toDisplayString(record.identificadorMovimento), 9, _hoisted_37)
                                  ]),
                                  ((record.nomePessoa))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                        _hoisted_39,
                                        _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", null, [
                                    _hoisted_40,
                                    _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataMovimento)), 1)
                                  ]),
                                  (record.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                        _createVNode(_component_a_tag, { class: "ss-tag-tipo pagamento" }),
                                        _createTextVNode("Pagamento")
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                        _createVNode(_component_a_tag, { class: "ss-tag-tipo recebimento" }),
                                        _createTextVNode("Recebimento")
                                      ])),
                                  _createElementVNode("span", null, [
                                    _hoisted_43,
                                    _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor,2)), 1)
                                  ])
                                ]))
                              : (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (_ctx.state.parametrosConsulta.formaVisualizacao === 2 && _ctx.servicoMovimentoFinanceiro.verificaSeMovimentoRelacionadoBaixa(record.recursoOrigem))
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.visualizarBaixa(record.codigo))
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(text), 1)
                                        ], 8, _hoisted_44))
                                      : (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.visualizar(record.codigo))
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(text), 1)
                                        ], 8, _hoisted_45))
                                  ], 64))
                                : (column.key === 'TipoMovimento')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      (record.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createVNode(_component_a_tag, { class: "ss-tag-tipo pagamento" }),
                                            _createTextVNode("Pagamento ")
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(_component_a_tag, { class: "ss-tag-tipo recebimento" }),
                                            _createTextVNode("Recebimento ")
                                          ], 64))
                                    ], 64))
                                  : (column.key === 'Conciliado')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(record.conciliado === true ? 'Sim' : 'Não'), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                          ((_ctx.state.parametrosConsulta.formaVisualizacao === 1 || _ctx.state.parametrosConsulta.formaVisualizacao === 2 && !_ctx.servicoMovimentoFinanceiro.verificaSeMovimentoRelacionadoBaixa(record.recursoOrigem)))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.visualizar(record.codigo)),
                                                title: "Visualizar"
                                              }, [
                                                _createVNode(_component_icone, { nome: "visualizar" })
                                              ], 8, _hoisted_48))
                                            : _createCommentVNode("", true),
                                          (_ctx.servicoMovimentoFinanceiro.verificaSeMovimentoPodeSerExcluido(record.recursoOrigem, record.excluido, record.movimentoIndividual))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                onClick: ($event: any) => (_ctx.confirmarExclusao(record)),
                                                title: "Excluir"
                                              }, [
                                                _createVNode(_component_icone, { nome: "excluir" })
                                              ], 8, _hoisted_49))
                                            : _createCommentVNode("", true),
                                          (_ctx.servicoMovimentoFinanceiro.verificaSeMovimentoRelacionadoBaixa(record.recursoOrigem))
                                            ? (_openBlock(), _createElementBlock("a", _hoisted_50, [
                                                _createVNode(_component_icone, {
                                                  nome: "documento-aprovado",
                                                  onClick: ($event: any) => (_ctx.visualizarBaixa(record.codigo))
                                                }, null, 8, ["onClick"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (record.transferencia)
                                            ? (_openBlock(), _createElementBlock("a", _hoisted_51, [
                                                _createVNode(_component_icone, {
                                                  nome: "troca",
                                                  onClick: ($event: any) => (_ctx.visualizarTransferencia(record.codigo))
                                                }, null, 8, ["onClick"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (!record.excluido)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                (!record.conciliado)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      title: "Conciliar",
                                                      onClick: ($event: any) => (_ctx.confirmarConciliacaoUnica(record))
                                                    }, [
                                                      _createVNode(_component_icone, { nome: "correto" })
                                                    ], 8, _hoisted_52))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                                          : (column.key === 'DataMovimento')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.storeSistema.state.layoutMobile? _ctx.UtilitarioData.aplicaFormatoDataAnoAbreviado(record.dataMovimento):_ctx.UtilitarioData.aplicaFormatoData(record.dataMovimento)), 1))
                                            : (column.key === 'Valor')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                                  (record.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, "-" + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                                ], 64))
                                              : (column.key === 'Saldo')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2, false, true)), 1))
                                                : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            (_ctx.telaBase.carregando)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  resultadoPesquisa: !_ctx.telaBase.carregando,
                                  mensagem: "Buscando informações, por favor aguarde..."
                                }, null, 8, ["resultadoPesquisa"]))
                              : (_ctx.state.apresentarResultados)
                                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                    key: 1,
                                    resultadoPesquisa: !_ctx.telaBase.carregando,
                                    mensagem: "Nenhum movimento na conta foi encontrado com estes filtros."
                                  }, null, 8, ["resultadoPesquisa"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "carregandoMovimentosFinanceiros", "scroll", "row-selection"])
                      ], 36),
                      ((_ctx.state.extratoConta.movimentos.length !== _ctx.state.movimentosVisiveis.length))
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            message: "Role para baixo para carregar mais movimentações.",
                            type: "info",
                            "show-icon": "",
                            closable: ""
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.storeSistema.state.layoutMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59))
                    : _createCommentVNode("", true)
                ]))
          ])
        ])
      ])
    ]),
    ((!_ctx.storeSistema.state.layoutMobile && _ctx.gradeBase.codigosSelecionados.length > 0 && _ctx.state.movimentosConciliar.length > 0))
      ? (_openBlock(), _createBlock(_component_card, {
          key: 0,
          class: "ss-acoes-massa-selecionados",
          titulo: "Ações em massa"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.textoCodigosSelecionados()), 1),
            _createElementVNode("div", _hoisted_60, [
              ((_ctx.state.movimentosConciliar.length > 0))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    title: "Concliliar",
                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.confirmarConciliacao()))
                  }, [
                    _createVNode(_component_icone, { nome: "checklist" }),
                    _createTextVNode(" Conciliar ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_movimento_financeiro_modal, {
      operacao: _ctx.state.operacaoLancamento,
      conta: _ctx.state.parametrosConsulta.conta,
      visivel: _ctx.state.exibirLancamento,
      "onUpdate:visivel": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
      onConfirmacao: _cache[38] || (_cache[38] = ($event: any) => (_ctx.buscarMovimentos()))
    }, null, 8, ["operacao", "conta", "visivel"]),
    _createVNode(_component_baixa_titulos_modal, {
      visivel: _ctx.state.exibirBaixa,
      "onUpdate:visivel": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.exibirBaixa) = $event)),
      empresa: _ctx.state.parametrosConsulta.empresa,
      movimento: _ctx.state.codigoMovimentoSelecionado,
      onConfirmacao: _cache[40] || (_cache[40] = ($event: any) => (_ctx.buscarMovimentos()))
    }, null, 8, ["visivel", "empresa", "movimento"]),
    _createVNode(_component_controle_periodo_movimentacao_contas_modal, {
      empresa: _ctx.state.parametrosConsulta.empresa,
      conta: _ctx.state.parametrosConsulta.conta,
      visivel: _ctx.state.exibirControlePeriodoMovimentacao,
      "onUpdate:visivel": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.exibirControlePeriodoMovimentacao) = $event))
    }, null, 8, ["empresa", "conta", "visivel"]),
    _createVNode(_component_transferencia_contas_modal, {
      empresa: _ctx.state.parametrosConsulta.empresa,
      visivel: _ctx.state.exibirTransferencia,
      "onUpdate:visivel": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.exibirTransferencia) = $event)),
      onConfirmacao: _cache[43] || (_cache[43] = ($event: any) => (_ctx.buscarMovimentos()))
    }, null, 8, ["empresa", "visivel"]),
    _createVNode(_component_transferencia_contas_visualizacao_modal, {
      empresa: _ctx.state.parametrosConsulta.empresa,
      movimento: _ctx.state.codigoMovimentoSelecionado,
      excluido: _ctx.state.parametrosConsulta.excluidos,
      visivel: _ctx.state.visualizarTransferencia,
      "onUpdate:visivel": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.visualizarTransferencia) = $event)),
      onConfirmacao: _cache[45] || (_cache[45] = ($event: any) => (_ctx.buscarMovimentos()))
    }, null, 8, ["empresa", "movimento", "excluido", "visivel"]),
    _createVNode(_component_importacao_extrato_ofx_modal, {
      empresa: _ctx.state.parametrosConsulta.empresa,
      conta: _ctx.state.parametrosConsulta.conta,
      visivel: _ctx.state.exibirImportacaoOfx,
      "onUpdate:visivel": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.state.exibirImportacaoOfx) = $event)),
      onConfirmacao: _cache[47] || (_cache[47] = ($event: any) => (_ctx.buscarMovimentos()))
    }, null, 8, ["empresa", "conta", "visivel"]),
    _createVNode(_component_importacao_retorno_bancario_modal, {
      empresa: _ctx.state.parametrosConsulta.empresa,
      conta: _ctx.state.contaSelecionada.codigo,
      visivel: _ctx.state.exibirImportacaoRetorno,
      "onUpdate:visivel": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.state.exibirImportacaoRetorno) = $event)),
      onConfirmacao: _cache[49] || (_cache[49] = ($event: any) => (_ctx.buscarMovimentos()))
    }, null, 8, ["empresa", "conta", "visivel"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ]))
}